import { useMemo } from 'react';

import { useProductOptionContext } from '../../context/ProductOptionProvider';
import { ProductOptionConfig } from '../../type/common.type';
import { orderQuantityTransformer } from '../../util/transformers/order-quantity-transformer';
import { productMetadataBuilder } from '../../util/transformers/product-metadata-transformer';

interface UseNoticeTextProps {
  config: ProductOptionConfig;
}

export const useNoticeText = ({ config }: UseNoticeTextProps) => {
  const { state } = useProductOptionContext();
  const product_metadata = productMetadataBuilder(state.option.info, config);

  const display_notice_text = useMemo(
    () =>
      (!config.hidden_flags?.first_order_notice_text && product_metadata.notice_state.first_order.display) ||
      (!config.hidden_flags?.order_quantity_notice_text && product_metadata.notice_state.order_quantity.display) ||
      (!config.hidden_flags?.store_deal_notice_text && product_metadata.notice_state.store_deal.display),
    [config.hidden_flags, product_metadata.notice_state],
  );
  return {
    display: display_notice_text,
    firstOrderDiscountAmount:
      !config.hidden_flags?.first_order_notice_text && product_metadata.notice_state.first_order.display
        ? product_metadata.notice_state.first_order.first_order_discount_amount
        : null,
    orderQuantity:
      !config.hidden_flags?.order_quantity_notice_text && product_metadata.notice_state.order_quantity.display
        ? {
            text: orderQuantityTransformer(
              product_metadata.notice_state.order_quantity.minimum_order_quantity,
              product_metadata.notice_state.order_quantity.maximum_order_quantity,
            ),
            display_recent_30days_note: product_metadata.notice_state.order_quantity.display_recent_30days_note,
          }
        : null,
    storeDealText:
      !config.hidden_flags?.store_deal_notice_text && product_metadata.notice_state.store_deal.display
        ? product_metadata.notice_state.store_deal.text
        : null,
  };
};
